import React from "react";
import styled from "styled-components";
import Skeleton from "common/NewLook/Skeleton.tsx";
import { getNewLookTokens, NEW_LOOK_RADIUS } from "common/NewLook/tokens.ts";

/** A group card while the marketplace loads, in the card's own shape. */
const GroupCardSkeleton = ({ showChart = true }: { showChart?: boolean }) => (
  <Card aria-hidden={true}>
    <Head>
      <Skeleton width={40} height={40} radius={10} />
      <Lines>
        <Skeleton width="60%" height={14} />
        <Skeleton width={72} height={10} />
      </Lines>
      <Skeleton width={52} height={26} radius={8} />
    </Head>
    <Stats>
      {[0, 1, 2].map((index) => (
        <Lines key={index}>
          <Skeleton width={48} height={10} />
          <Skeleton width={64} height={18} />
        </Lines>
      ))}
    </Stats>
    {showChart && (
      <Chart>
        <Skeleton width="100%" height={88} radius={8} />
      </Chart>
    )}
    <Footer>
      <Skeleton width={64} height={16} />
      <Skeleton width={96} height={12} />
    </Footer>
  </Card>
);

export default React.memo(GroupCardSkeleton);

const Card = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: ${(p) => getNewLookTokens(p.theme).panel};
  border: ${(p) => p.theme.borders.panel};
  box-shadow: ${(p) => p.theme.shadows.panel};
  border-radius: ${NEW_LOOK_RADIUS.panel}px;
`;
const Head = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 16px 0;
`;
const Lines = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
`;
const Stats = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin: 16px 16px 0;
  padding: 10px 12px;
  border-radius: ${NEW_LOOK_RADIUS.control}px;
  box-shadow: inset 0 0 0 1px ${(p) => getNewLookTokens(p.theme).hairline};
`;
const Chart = styled.div`
  flex: 1;
  padding: 16px 16px 0;
`;
const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 48px;
  margin-top: 16px;
  padding: 0 16px;
  border-top: 1px solid ${(p) => getNewLookTokens(p.theme).hairline};
`;
